import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  JunctionStatusOptionsTypes,
  TableHeaderProps,
} from "../../../../../utils/types";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
  GridAlignment,
} from "@mui/x-data-grid-pro";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import NoData from "../../../../../images/NoData.svg";
import { useLazyQuery } from "@apollo/client";
import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import {
  emptyFunc,
  FETCH_MORE_DATA,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import {
  GetJunctionsData,
  GetJunctionsVars,
  JunctionEdge,
} from "../../masters/subsidary/junctions/queries/types";
import { GetJunctions } from "../../masters/subsidary/junctions/queries/queries";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { AtsSubsidiaryOrderField } from "../../masters/subsidary/queries/types";
import MultipleJunctionTypesAutocomplete from "../../../../../customComponents/JunctionTypesAutcomplete";
import useLabels from "../../../../../customHooks/useLabels";
import SiteSelect from "../../../../../customComponents/SiteSelect";
import { payloadTypes } from "../../../../../context/reducer";
import SubsidiarySelect from "../../../../../customComponents/SubsidiarySelect";
import CompaniesAutocomplete from "../../../customer/companies/CompaniesAutocomplete";
import { AppContext } from "../../../../../context/context";
import Input from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { mapsPayloadType } from "../../maps/context/reducer";
import { MapsContext } from "../../maps/context/context";
import {
  CustomModal,
  getJunctionStatusDetails,
} from "../../../../../utils/UtilFunctions";
import JunctionStatusAutocomplete from "../../masters/subsidary/junctions/customComponenets/JunctionStatusAutocomplete";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import Finalize from "../../../../../images/Finalize.svg";
import { TableType } from "../../../customer/companies/queries/types";
import { ViewRaisedTicketModalStyles } from "../../../../../styles/CustomModalStyles";
import { StateTypes } from "../../maps/Maps";
import { AssetDetailsPageFor } from "../../maps/ticketing/junctionDetails/raisedTickets/AssetDetails";
import RaisedTicketDetails from "../../maps/ticketing/junctionDetails/raisedTickets/RaisedTicketDetails";
import Working from "../../../../../images/dashboard/Working.svg";
import NotWorking from "../../../../../images/dashboard/Not Working.svg";

interface Props {
  setRaiseTicketPage: (value: React.SetStateAction<boolean>) => void;
  setModalFlag: (value: React.SetStateAction<boolean>) => void;
  modalFlag: boolean;
}

const FilterTickets = ({
  setModalFlag,
  modalFlag,
  setRaiseTicketPage,
}: Props) => {
  const { Reports } = useAssetTableJson();
  const { state, dispatch } = useContext(AppContext);
  const { state: stateMap, dispatch: dispatchMap } = useContext(MapsContext);
  const { dispatch: mapsDispatch } = useContext(MapsContext);
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState("");
  const { user_details } = useLoggedInUserDetails();
  const { customer_id, company_id, sub_id, siteID, supplier_id } =
    useUrlParams();
  const [selectJunctionTypes, setSelectJunctionTypes] = useState<string[]>([]);
  const [statusSelected, setStatusSelected] =
    useState<JunctionStatusOptionsTypes | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [junctions, setJunctions] = useState<JunctionEdge[]>([]);

  const [raisedTicketModal, setRaisedTicketModal] = useState<StateTypes>({
    itemId: 0,
    flag: false,
    tableLevel: TableType.COMPANY,
  });

  const { junctionLabel, companyLabel, subsidiaryLabel, subsidiarySiteLabel } =
    useLabels();
  const [getJunctions, { data, loading, fetchMore }] = useLazyQuery<
    GetJunctionsData,
    GetJunctionsVars
  >(GetJunctions);
  useEffect(() => {
    if (customer_id) {
      getJunctions({
        variables: {
          after: null,
          customerID: customer_id,
          companyID: state.companyId
            ? state.companyId
            : company_id
            ? company_id
            : 0,
          first: ROWS_PER_PAGE,
          empID: user_details.id,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsSubsidiaryOrderField.NAME,
          },
          priority: [],
          jType: selectJunctionTypes.length
            ? selectJunctionTypes
            : [state.junctionType],
          name: searchData,
          subsidiaryID: state.subsidiaryId
            ? state.subsidiaryId
            : sub_id
            ? sub_id
            : 0,
          siteID: state.subSiteId ? state.subSiteId : siteID ? siteID : 0,
          ldgrID: supplier_id ? supplier_id : 0,
          junctionStatus: statusSelected ? [statusSelected.value] : [],
        },
      });
    }
  }, [
    getJunctions,
    customer_id,
    company_id,
    sub_id,
    supplier_id,
    state.companyId,
    state.subsidiaryId,
    state.subSiteId,
    user_details.id,
    state.junctionType,
    siteID,
    searchData,
    statusSelected,
    selectJunctionTypes,
  ]);

  const handleScroll = () => {
    if (hasNextPage && !loading) {
      fetchMore({
        variables: {
          first: FETCH_MORE_DATA,
          after: endCursor,
        },
        updateQuery: (prevResult, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prevResult;

          const newEdges = fetchMoreResult.GetJunctions.edges;
          const pageInfo = fetchMoreResult.GetJunctions.pageInfo;
          setEndCursor(pageInfo.endCursor);
          setHasNextPage(pageInfo.hasNextPage);

          const duplicateCheck = prevResult.GetJunctions.edges.filter(
            ({ node: { id } }) =>
              newEdges.findIndex(({ node: { id: newId } }) => newId === id) !==
              -1
          );

          if (duplicateCheck.length > 0) return prevResult;

          return {
            GetJunctions: {
              edges: [...junctions, ...newEdges],
              pageInfo,
              totalCount: data ? data.GetJunctions.totalCount! : 0,
            },
          };
        },
      });
    }
  };
  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetJunctions.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = junctions.find(
            (sub) => sub.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setJunctions(updatedNewData);
      } else {
        setJunctions(newData);
      }

      setEndCursor(data.GetJunctions.pageInfo.endCursor);
      setHasNextPage(data.GetJunctions.pageInfo.hasNextPage);
    } // eslint-disable-next-line
  }, [data, loading]);
  const dynamicHeaders: TableHeaderProps[] = Reports.VendorWiseJunctions.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        const statusDetails = getJunctionStatusDetails(params.row.status);

        if (header.field === "actions") {
          return (
            <>
              {params.row.ticketStatus === "OPEN" ? (
                <button
                  className="maps-comp-details__view"
                  onClick={() => {
                    dispatchMap({
                      type: mapsPayloadType.ASSET_TYPE_ID,
                      payload: {
                        assetTypeId: params.row.juctionItemId,
                      },
                    });
                    setRaisedTicketModal({
                      flag: true,
                      itemId: 0,
                      tableLevel: TableType.JUNCTION,
                    });
                  }}
                >
                  View Ticket
                  <img src={Finalize} alt="" />
                </button>
              ) : (
                <button
                  className="maps-comp-details__raise"
                  onClick={() => {
                    dispatchMap({
                      type: mapsPayloadType.ASSET_TYPE_ID,
                      payload: {
                        assetTypeId: params.row.juctionItemId,
                      },
                    });
                    setModalFlag(false);
                    setRaiseTicketPage(true);
                    handleClear();
                  }}
                >
                  Raise Ticket
                  <img src={Finalize} alt="" />
                </button>
              )}
            </>
          );
        } else if (header.field === "ticketStatus") {
          return (
            <>
              {params.row.ticketStatus === "OPEN" ? (
                <div>
                  <img src={NotWorking} alt={"NotWorking"} />
                  <span>Tickets Raised</span>
                </div>
              ) : (
                <div>
                  <img src={Working} alt={"Working"} />
                  <span>Working</span>
                </div>
              )}
            </>
          );
        } else if (header.field === "status") {
          return (
            <div>
              {statusDetails.image && (
                <img src={statusDetails.image} alt={statusDetails.value} />
              )}
              <span>{statusDetails.value}</span>
            </div>
          );
        }

        return params.value;
      },
    })
  );

  const columns: GridColDef[] = [...dynamicHeaders];
  const rows: GridValidRowModel[] = useMemo(() => {
    return junctions.map(({ node: data }, index) => {
      return {
        id: index + 1,
        junc_no: data.code,
        junc_desc: data.name,
        junc_alias: data.alias,
        company: data.company.name,
        subsidiary: data.subsidiary.name,
        subsidiary_site: data.site.name,
        junc_type: data.jType,
        status: data.junctionStatus,
        juctionItemId: data.id,
        ticketStatus: data.ticketStatus,
      };
    });
  }, [junctions]);
  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({
      id: true,
      junc_no: true,
      junc_desc: true,
      junc_alias: true,
      company: false,
      subsidiary: false,
      subsidiary_site: false,
      junc_type: true,
      junc_status: true,
      actions: true,
    });

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.VENDOR_WISE_JUNCTIONS
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.VENDOR_WISE_JUNCTIONS,
      JSON.stringify(newModel)
    );
  };

  const handleClear = () => {
    setSelectJunctionTypes([]);
    setStatusSelected(null);
    dispatch({
      type: payloadTypes.SET_COMPANY_ID,
      payload: {
        companyId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_ID,
      payload: {
        subsidiaryId: 0,
      },
    });
    dispatch({
      type: payloadTypes.SET_SUB_SITE_ID,
      payload: {
        subSiteId: 0,
      },
    });
  };

  return (
    <>
      <div className="cust_users__title">
        <Title>Raise Ticket</Title>
        {modalFlag && (
          <>
            <img
              src={Close}
              alt=""
              onClick={() => {
                setModalFlag(false);
                handleClear();
              }}
            />
          </>
        )}
      </div>

      <div className="cust_users--modal">
        <div className="row g-0 cust_users--filters">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchData(e.target.value);
              }}
            />
          </div>
          <div className="col">
            <CompaniesAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_COMPANY_ID,
                    payload: {
                      companyId: newValue.node.id,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_COMPANY_ID,
                    payload: {
                      companyId: 0,
                    },
                  });
                  dispatch({
                    type: payloadTypes.SET_SUB_ID,
                    payload: {
                      subsidiaryId: 0,
                    },
                  });
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: 0,
                    },
                  });
                }
              }}
              onKeyDown={emptyFunc}
              value={state.companyId ? state.companyId : 0}
              label={companyLabel}
            />
          </div>
          <div className="col">
            <SubsidiarySelect
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_SUB_ID,
                    payload: {
                      subsidiaryId: newValue.node.id,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_SUB_ID,
                    payload: {
                      subsidiaryId: 0,
                    },
                  });
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: 0,
                    },
                  });
                }
              }}
              onKeyDown={emptyFunc}
              companyID={state.companyId ? state.companyId : 0}
              value={state.subsidiaryId ? state.subsidiaryId : 0}
              label={subsidiaryLabel}
            />
          </div>
          <div className="col">
            <SiteSelect
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: newValue.value,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: 0,
                    },
                  });
                }
              }}
              companyId={state.companyId ? state.companyId : 0}
              subsidiaryId={state.subsidiaryId ? state.subsidiaryId : 0}
              onKeyDown={emptyFunc}
              value={state.subSiteId ? state.subSiteId : 0}
              label={subsidiarySiteLabel}
            />
          </div>

          <div className="col">
            <JunctionStatusAutocomplete
              onChange={(newValue) => {
                setStatusSelected(newValue);
              }}
              value={statusSelected ? statusSelected.value : null}
              onKeyDown={emptyFunc}
              label={`${junctionLabel} Status`}
            />
          </div>
          <div className="col">
            <MultipleJunctionTypesAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  setSelectJunctionTypes(newValue);
                } else {
                  setSelectJunctionTypes([]);
                }
              }}
              onKeyDown={emptyFunc}
              autoCompleteValue={selectJunctionTypes}
              label={`${junctionLabel} Type`}
              handleClear={emptyFunc}
            />
          </div>
        </div>
        <div className={`cust_users__tableblock`}>
          {junctions.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
              onRowsScrollEnd={handleScroll}
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <div className="row g-0">
          <div className="col">
            <Button
              mode="cancel"
              onClick={() => {
                setModalFlag(false);
                handleClear();
              }}
            />
          </div>
          <div className="col flex-end">
            <div className="overall-total-count">
              Total {junctionLabel}'s{" "}
              <b>{data ? data.GetJunctions.totalCount : 0}</b>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        style={ViewRaisedTicketModalStyles}
        isOpen={raisedTicketModal.flag}
        onRequestClose={() =>
          setRaisedTicketModal({
            flag: false,
            itemId: 0,
            tableLevel: TableType.COMPANY,
          })
        }
        contentComponent={
          <RaisedTicketDetails
            setModalFlag={() =>
              setRaisedTicketModal({
                flag: false,
                itemId: 0,
                tableLevel: TableType.CUSTOMER,
              })
            }
            assetType={TableType.JUNCTION}
            pageFor={AssetDetailsPageFor.MAPS}
            itemsView={false}
          />
        }
      />
    </>
  );
};

export default FilterTickets;
